<template functional>
  <nav class="top-navigation-bar">
    <div class="container top-navigation-container">
      <div class="level is-mobile top-navigation is-vcentered">
        <div class="level-left">
          <slot name="level-left"></slot>
        </div>
        <div class="level-right">
          <slot name="level-right"></slot>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TopNavigation'
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/components/level';
@import '~bulma/sass/elements/container';

.top-navigation-bar {
  background-color: $black;

  .top-navigation-container {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.top-navigation {
  height: 40px;
}
</style>
